import type { AnnouncementDetailResource } from '@/api/@types'

export const announcementKeyFactory = {
  all: [{ scope: 'announcement' }] as const,
  announcements: () =>
    [{ ...announcementKeyFactory.all[0], entity: 'announcements' }] as const,
  detail: ({
    pathParams,
  }: {
    pathParams: { announcementId: AnnouncementDetailResource['id'] }
  }) =>
    [
      { ...announcementKeyFactory.all[0], entity: 'detail', pathParams },
    ] as const,
}
